goog.provide('el8.appchart.dialog.addEditAmendmentRequest');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.template.appchart.dialog.addEditAmendmentRequest');
goog.require('el8.util.consts');
goog.require('el8.appshared.form.buttons');
goog.require('el8.ptdata.model.amendmentRequest');


el8.appchart.dialog.addEditAmendmentRequest = (function() {

    var currAmendmentRequest = null;
    var getAmendmentRequestFn, saveAmendmentRequestFn = null;

    var STATUS_CHOICES = [
        ['', '- Choose one -'],
        ['accepted', 'Accepted'],
        ['denied', 'Denied']
    ];
    var SOURCE_CHOICES = [
        ['patient', 'Patient'],
        ['provider', 'Provider/Organization']
    ];

    var that = new el8.uiwidget.FormDialog({
        title: 'Patient Amendment Request',
        autoHeight: true,
        width: 450,
        contentFn: function() {
            return el8.template.appchart.dialog.addEditAmendmentRequest.form({
                statusChoices: STATUS_CHOICES,
                sourceChoices: SOURCE_CHOICES
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'requestDescription',
                selector: ':input[name="requestDescription"]',
                infoText: 'Describe amendment request...',
                height:  6*el8.util.consts.DEFAULT_FIELD_HEIGHT
            },
            {
                name: 'requestDate',
                selector: ':input[name="requestDate"]',
                infoText: 'date...',
                datePickerOpts: {}
            },
            {
                name: 'requestTime',
                selector: ':input[name="requestTime"]',
                timePickerOpts: {
                    increment: 1
                }
            },
            {
                name: 'amendmentSource',
                selector: ':input[name="amendmentSource"]'
            },
            {
                name: 'status',
                selector: ':input[name="status"]'
            }
        ]
    });

    var doSave = function(_form) {

        // Populates everything correctly except for requestTime
        var mapped = form.getMapped();
        currAmendmentRequest.populate(mapped);

        // Manually extract requestTime
        var requestTime = el8.service.tz.processDateAndTimeInputs(
            _form.getVal('requestDate'), _form.getVal('requestTime'));
        currAmendmentRequest.setRequestTime(requestTime);

        // Do validation
        if (!currAmendmentRequest.getRequestDescription()) {
            el8.uiwidget.alert('Please enter a description of the amendment request.');
            return;
        }
        if (!currAmendmentRequest.getStatus()) {
            el8.uiwidget.alert('Please choose a status of the request');
            return;
        }
        if (!currAmendmentRequest.getRequestTime()) {
            el8.uiwidget.alert('Please enter the date and time request was made.');
            return;
        } else if (el8.util.datecompare.isAfterToday(currAmendmentRequest.getRequestTime())) {
            el8.uiwidget.alert('Time of request cannot be later than today.');
            return;
        }

        saveAmendmentRequestFn(currAmendmentRequest, function() { that.hide(); });

    };

    form.addSaveButton(function(_form) {
        doSave(_form);
    }, true);
    form.addDiscardButton(function() {
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {

        super_show.call(that);
        spec = spec || {};

        getAmendmentRequestFn = spec.getAmendmentRequestFn;
        saveAmendmentRequestFn = spec.saveAmendmentRequestFn;

        currAmendmentRequest = getAmendmentRequestFn() || el8.ptdata.model.amendmentRequest();
        if (currAmendmentRequest.getId()) {
            that.setTitle('Edit Patient Amendment Request');
            form.showDiscardChangesCaption();
            form.populate({
                'requestDescription': currAmendmentRequest.getRequestDescription(),
                'status': currAmendmentRequest.getStatus(),
                'amendmentSource': currAmendmentRequest.getAmendmentSource(),
                'requestDate': currAmendmentRequest.getRequestTime().asString(),
                'requestTime': currAmendmentRequest.getRequestTime().asTimeString()
            });
        } else {
            that.setTitle('Patient Amendment Request');
            form.showDiscardCaption();
            var now = el8.service.tz.now();
            form.setVal('requestDate', now.asString());
            form.setVal('requestTime', now.asTimeString());
        }
        form.initFocus();
    };

    var super_hide = that.hide;
    that.hide = function() {
        currAmendmentRequest = null;
        getAmendmentRequestFn = null;
        saveAmendmentRequestFn = null;
        super_hide.call(that);
    };

    return that;

})();

